<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-2">
        {{ $t("edit") }} {{ $tc("translations") }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Translations List' }">{{
        $tc("translations")
      }}</router-link>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-sm-3">
          <div class="input-material">
            <input
              id="translation_id"
              name="translation_id"
              :disabled="true"
              v-model="translation_details.translation_id"
              placeholder="."
            />
            <label>Translation Id</label>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="input-material">
            <input
              id="module"
              name="module"
              :disabled="true"
              v-model="translation_details.module"
              placeholder="."
            />
            <label>module</label>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="input-material">
            <input
              id="category"
              name="category"
              :disabled="true"
              v-model="translation_details.category"
              placeholder="."
            />
            <label>Category</label>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="input-material">
            <input
              id="key"
              name="key"
              :disabled="true"
              v-model="translation_details.key"
              placeholder="."
            />
            <label>key</label>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12">
          <TranslationsContainer
            :translationsObj="translationsObj"
            :skip="['en', 'de', 'fr', 'it']"
          />
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-sm-6" v-if="checkAvailableLang('de')">
          <div class="input-material">
            <input
              id="de"
              name="de"
              v-validate="'required'"
              v-model="translation_details.de"
              placeholder="."
            />
            <label>DE</label>
          </div>
        </div>
        <div class="col-sm-6" v-if="checkAvailableLang('en')">
          <div class="input-material">
            <input
              id="en"
              name="en"
              v-validate="'required'"
              v-model="translation_details.en"
              placeholder="."
            />
            <label>EN</label>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-sm-6" v-if="checkAvailableLang('fr')">
          <div class="input-material">
            <input
              id="fr"
              name="fr"
              v-validate="'required'"
              v-model="translation_details.fr"
              placeholder="."
            />
            <label>FR</label>
          </div>
        </div>
        <div class="col-sm-6" v-if="checkAvailableLang('it')">
          <div class="input-material">
            <input
              id="it"
              name="it"
              v-validate="'required'"
              v-model="translation_details.it"
              placeholder="."
            />
            <label>IT</label>
          </div>
        </div>
      </div>

      <div class="mt-5 mb-5">
        <div class="input-material">
          <input
            id="remark"
            name="remark"
            v-validate="'required'"
            v-model="translation_details.remark"
            placeholder="."
          />
          <label>Remark</label>
        </div>
      </div>
      <div class="text-center">
        <button class="btn-blue" @click="updateTranslation">Save</button>
        <button
          class="btn-outline-blue"
          @click="() => $router.push({ name: 'Translations List' })"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import Languages from "@/helper/formJSONMaster/Languages";
import TranslationsContainer from "@/components/Partials/translationsFields.vue";
import Vue from "vue";

import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import moment from "moment";
import ImageGallery from "../../ImageGallery/imageGalleryModal";
import { mapGetters } from "vuex";

export default {
  components: { VueCropper, ImageGallery, TranslationsContainer },
  data() {
    return {
      translationsObj: {},
      submitted: false,
      btenable: false,
      en: null,
      translation_details: {},
      copiedData: {},
      banner_name: "",
      banner_header: "",
      banner_subheader: "",
      banner_is_active: true,
      fade: true,
      banner_description: "",
      banner_image: {
        image_setting_name: "Banner Image",
        image_setting_path: null,
        image_setting_static_path: "",
        image_setting_baseurl: "",
        image_setting_showpath: ""
      },
      file: null,
      filename: null,
      width: null,
      height: null,
      cropImg: null,
      tempModalImageName: null,
      tempModalImagePath: null,
      imgSrc: null,
      MovieList: [],
      MovieListCopy: [],
      movie_name: "",
      movie_id: null,
      searchMovie: "",
      isMovieSelected: false,
      isGenericURL: false,
      generic_url: "",
      showMovie: true,
      banner_type_id: null,
      banner_type: "",
      banner_types: [],
      MovieContentContainer: [],
      postersList: [],
      scenesList: [],
      cinemas: [],
      cinema_id: null,
      cinemaSelected: null,
      CinemasGroupedByRegion: [],
      selectedCinema: [],
      ContentLanguages: [],
      BannerContent: [],
      translationLoading: [false, false, false, false, false, false],
      translated: [false, false, false, false, false, false],
      unique_id: "",
      from_date: "",
      to_date: "",
      banner_image_height: "",
      banner_image_width: "",
      imageBannerIndex: "",
      set_width: null,
      set_height: null,
      showModal: false,
      ContentLanguages: []
    };
  },
  beforeMount() {
    this.getContentLangauge();
  },
  mounted() {
    this.getTranslation({
      perPage: 10,
      currentPage: 1,
      translation_id: this.$route.params.t_id
    });
    // this.cinema_id = this.secureStore.get("USINFO").cinema_id || null;
    // this.getCinemas();
    // const { b_id } = this.$route.params;
    // this.unique_id = b_id;
    //
    // this.getBannerTypes();
  },

  //   watch: {
  //     finalImagePath(newval) {
  //       this.BannerContent[
  //         this.imageBannerIndex
  //       ].banner_image.image_setting_path = newval;
  //       this.BannerContent[
  //         this.imageBannerIndex
  //       ].isNewUpload = true;
  //       this.$forceUpdate();
  //     }
  //   },
  methods: {
    checkAvailableLang(iso_2) {
      let tempArray = [];
      tempArray = this.ContentLanguages.filter(
        x => x.iso_2.toLowerCase() == iso_2.toLowerCase()
      );
      if (tempArray.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    getContentLangauge: function() {
      MovieService.GetMovieContentLanguages()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              this.ContentLanguages = data.ContentLanguages;
            }
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {});
    },
    setModalData(height, width, index) {
      this.imageBannerIndex = index;
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
    getTranslation(payload) {
      console.log("payload :>> ", payload);
      MasterService.GetAllTranslations(payload).then(res => {
        console.log("res :>> ", res);
        this.translation_details = res.data.Records.data.length
          ? res.data.Records.data[0]
          : {};

        if (this.translation_details.extraLangs) {
          let extraLangs = {}
          try {
            extraLangs = JSON.parse(this.translation_details.extraLangs)
          } catch (e) {
          }

          if (!!extraLangs && extraLangs !== 'null' &&  extraLangs !== 'undefined' &&  extraLangs !== '[]' &&  extraLangs !== '{}') {
            this.translationsObj = extraLangs
          }
          this.$forceUpdate()
        }

        const d = JSON.stringify(this.translation_details);
        this.copiedData = d;

      });
    },
    updateTranslation() {
      let payload = {};
      // console.log(
      //   "this.translation_details.fr :>> ",
      //   this.translation_details.fr
      // );
      // console.log("this.copiedData.fr :>> ", JSON.parse(this.copiedData).fr);
      payload.translation_id = this.$route.params.t_id;
      payload.remark = this.translation_details.remark;
      const copiedData = JSON.parse(this.copiedData);
      console.log(
        "this.translation_details.fr === this.copiedData.fr :>> ",
        this.translation_details.fr === copiedData.fr
      );
      const en =
        this.translation_details.en === copiedData.en
          ? null
          : this.translation_details.en;
      const de =
        this.translation_details.de === copiedData.de
          ? null
          : this.translation_details.de;
      const fr =
        this.translation_details.fr === copiedData.fr
          ? null
          : this.translation_details.fr;
      const it =
        this.translation_details.it === copiedData.it
          ? null
          : this.translation_details.it;
      if (en) {
        payload.en = en;
      } else {
        delete payload.en;
      }
      if (de) {
        payload.de = de;
      } else {
        delete payload.de;
      }
      if (fr) {
        payload.fr = fr;
      } else {
        delete payload.fr;
      }
      if (it) {
        payload.it = it;
      } else {
        delete payload.it;
      }

      if (Object.keys(this.translationsObj).length) {
        payload.extraLangs = this.translationsObj
      }

      console.log("payload :>> ", payload);
      MasterService.UpdateTranslation(payload).then(res => {
        console.log("res :>> ", res);
        this.$toasted.show("Translation Updated");
        this.$router.push({ name: "Translations List" });
      });
    },

    resetFromDate(type) {
      if (type == "from_date") {
        this.from_date = "";
      } else if (type == "to_date") {
        this.to_date = "";
      }
    }
  }
};
</script>

<style scoped>
.dropdown-toggle {
  width: 100%;
}

.btn-dropdown-curve {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.img-preview:hover {
  left: -430px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TranslationsComponent/EditTranslation.vue